// extracted by css-extract-rspack-plugin
export default {"dateField":"DateRow__dateField--pvN12"};